module.exports = __webpack_public_path__ + "static/devops-3eaf2e4fdf83c1c81854c3a3bb3a5d64.jpg";